import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://cbrwgraitvmocikabmzh.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNicndncmFpdHZtb2Npa2FibXpoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODEyNTkzMTAsImV4cCI6MjA5NjgzNTMxMH0.OIbD26AVK_gu0h0Woc-7PIJPdpBjuxniU3XqbQkVuYk'

export const supabase = createClient(supabaseUrl, supabaseKey)
